import { CustomArrowProps } from 'react-slick';

import { NextIcon, PrevIcon } from '@/app/assets/Icons';
import { cn } from '@nextui-org/react';

interface IProps {
	onPrev: () => void;
	onNext: () => void;
	className?: string;
	btnClass?: string;
}

export const SlideController: React.FC<IProps> = (props) => {
	return (
		<div
			className={cn(
				'row mt-3 justify-center gap-5 lg:hidden',
				props.className
			)}
		>
			<button
				type="button"
				className={cn(
					`center size-6 rounded-full lg:size-[50px]`,
					props.btnClass
				)}
				onClick={props.onPrev}
			>
				<PrevIcon className="text-bittersweet stroke-2 lg:stroke-[3]" />
			</button>
			<button
				type="button"
				className={cn(
					`center size-6 rounded-full lg:size-[50px]`,
					props.btnClass
				)}
				onClick={props.onNext}
			>
				<NextIcon className="text-bittersweet stroke-2 lg:stroke-[3]" />
			</button>
		</div>
	);
};

export const NextArrow = (props: CustomArrowProps) => {
	const { className, onClick } = props;
	return (
		<button
			className={cn(
				`center absolute -right-16 top-1/2 z-[9999] size-6 rounded-full max-sm:!hidden lg:size-[50px]`
			)}
			onClick={onClick}
		>
			<NextIcon className="text-bittersweet stroke-2 lg:stroke-[3]" />
		</button>
	);
};

export const PrevArrow = (props: CustomArrowProps) => {
	const { className, onClick } = props;
	return (
		<button
			className={cn(
				`center absolute -left-16 top-1/2 z-[9999] size-6 rounded-full max-sm:!hidden lg:size-[50px]`
			)}
			onClick={onClick}
		>
			<PrevIcon className="text-bittersweet stroke-2 lg:stroke-[3]" />
		</button>
	);
};
